// eslint-disable-next-line @typescript-eslint/no-explicit-any
let DEBOUNCE_TIMER: any;

export const debounce = (handler: () => void, timeout: number) => {
  clearTimeout(DEBOUNCE_TIMER);
  DEBOUNCE_TIMER = setTimeout(handler, timeout);
};